import React from "react";
import { insertFonts } from "../../helpers/fontHelper";
import { MeetingLayoutModule } from "./MeetingLayoutModule";
import { combineProps } from "../../helpers/objectHelper";
import { useMediaQuery } from "@material-ui/core";
import json2mq from "json2mq";
import { FontBasline } from "./shared/FontBaseline";
import { isUsingSafari } from "../../helpers/browser.helper";

export function MeetingLayout(props) {
  const { fonts, template, modules, noFontLoad, hasParent, mobile } = props;
  const { main } = template;
  return (
    <ViewWrapper {...combineProps([{ fonts, template, style: main, modules, noFontLoad, hasParent, mobile }])}>
      {props.children}
      <ModuleHandler {...props} />
    </ViewWrapper>
  );
}

export function FontInjector(props) {
  const { fonts, noFontLoad } = props;
  if (!fonts || noFontLoad) return null;
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: insertFonts(fonts),
      }}
    />
  );
}

function ViewWrapper(props) {
  //Mobile support (check if scroll)
  const isSmartphone = useMediaQuery(
    json2mq({
      maxWidth: 1280,
    })
  );
  const { children, style, noFontLoad, hasParent, mobile } = props;
  let height = hasParent ? (isSmartphone ? "calc(100% - 50px)" : "calc(100% - 50px)") : mobile && isSmartphone ? window.innerHeight : "100vh";

  /*  if (isUsingSafari() && hasParent && isSmartphone) {
    height = "calc(100% - 100px)";
  }
 */
  const layoutStyle = isSmartphone
    ? {
        ...style,
        width: "100%",
        height,
        position: "relative",
        overflow: mobile || hasParent ? "auto" : hasParent ? "hidden" : "hidden auto",

        /*         minHeight: mobile ? "100vh" : undefined, */
      }
    : {
        ...style,
        width: "100%",
        height,
        position: "relative",
        overflow: mobile || hasParent ? "auto hidden" : "hidden",
      };

  return (
    <div id="view-wrapper" className={mobile && !hasParent ? "mobile" : ""} style={{ ...layoutStyle }}>
      {noFontLoad != true ? <FontBasline {...props} /> : null}
      {children}
    </div>
  );
}

// function DesktopViewWrapper(props) {
//   const { children, style } = props;
//   return (
//     <div
//       id="view-wrapper"
//       style={{
//         ...style,
//         width: "100%",
//         height: "100vh",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {children}
//     </div>
//   );
// }

// function SmartphoneViewWrapper(props) {
//   const { children, style } = props;
//   return (
//     <div
//       id="view-wrapper"
//       style={{
//         ...style,
//         width: "100%",
//         height: "100vh",
//         position: "relative",
//         overflow: "hidden auto",
//       }}
//     >
//       {children}
//     </div>
//   );
// }

function ModuleHandler(props) {
  //Mobile support (sort by sortorder)
  const { layout, modules, moduleIsInLayout, moduleBlueprint } = props;
  if (!Array.isArray(modules)) return null;
  return modules
    .filter(moduleIsInLayout)
    .sort((a, b) => {
      return a.sortOrder - b.sortOrder;
    })
    .map((m, i) => {
      return (
        <div key={m.meetingModuleId}>
          <MeetingLayoutModule {...combineProps([m, moduleBlueprint(m.meetingModuleId), props])} />
        </div>
      );
    });
}
